import { useState, useEffect, useCallback, useRef } from 'react'
import { authFetch } from '../services/api'

export function usePartnerStatus() {
  const [partnerStatus, setPartnerStatus] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const mountedRef = useRef(true)
  const intervalRef = useRef(null)

  const fetchPartnerStatus = useCallback(async () => {
    try {
      const response = await authFetch('/api/artists/me/partner')
      if (!response.ok) {
        if (response.status === 404) {
          if (mountedRef.current) { setPartnerStatus(null); setLoading(false) }
          return
        }
        throw new Error('Erreur lors du chargement du statut partenaire.')
      }
      const data = await response.json()
      if (mountedRef.current) { setPartnerStatus(data); setError(null) }
    } catch (err) {
      if (mountedRef.current) { setError(err.message); setPartnerStatus(null) }
    } finally {
      if (mountedRef.current) setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchPartnerStatus()
    intervalRef.current = setInterval(fetchPartnerStatus, 5 * 60 * 1000)
    return () => { if (intervalRef.current) clearInterval(intervalRef.current) }
  }, [fetchPartnerStatus])

  useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false } }, [])

  return { partnerStatus, loading, error, refresh: fetchPartnerStatus }
}
